const PASSWORD_RESET_ERROR_MESSAGES: Readonly<Record<string, string>> = {
  'auth/expired-action-code': 'A link lejárt. Kérj új jelszó-visszaállító levelet.',
  'auth/invalid-action-code': 'A link érvénytelen vagy már felhasználták. Kérj új jelszó-visszaállító levelet.',
  'auth/user-disabled': 'Ez a fiók le van tiltva.',
  'auth/user-not-found': 'Ehhez a linkhez már nem tartozik fiók.',
  'auth/weak-password': 'A jelszó túl gyenge: legalább 6 karakter legyen.',
  'auth/network-request-failed': 'Nincs internetkapcsolat. Próbáld újra.',
  'auth/too-many-requests': 'Túl sok próbálkozás. Próbáld újra később.',
}

export const NOT_A_PASSWORD_RESET_LINK = 'Ez a link nem jelszó-visszaállításhoz tartozik.'

export function passwordResetErrorMessage(error: unknown): string {
  const code = (error as { code?: string } | undefined)?.code ?? ''
  return PASSWORD_RESET_ERROR_MESSAGES[code] ?? 'Hiba történt a jelszó visszaállítása során. Próbáld újra.'
}
